import { Chip, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import { translationKeyForCount } from "~/features/preview/bins/binSettings.utils";
import { FlaggedReason } from "~/redux/warehouse/bins.openApi";

type FlagChipSectionProps = {
  flags: FlaggedReason[];
  selectedFlags: ReadonlySet<FlaggedReason>;
  flagCounts: Record<FlaggedReason, number>;
  onToggleFlag: (flag: FlaggedReason) => void;
};

export function BulkCleanBinFlagChips(props: FlagChipSectionProps) {
  const { flags, selectedFlags, flagCounts, onToggleFlag } = props;
  const { t } = useTranslation();

  return (
    <Stack direction="row" flexWrap="wrap" gap={1}>
      {flags.map((flag) => {
        const count = flagCounts[flag];
        const selected = selectedFlags.has(flag);
        const flagLabel = t(flag);
        const formattedCount = count.toLocaleString();

        return (
          <Chip
            key={flag}
            size="small"
            clickable
            {...(selected
              ? { color: "1" as const, variant: "filled" as const }
              : { variant: "outlined" as const })}
            disabled={count === 0}
            label={`${flagLabel} (${formattedCount})`}
            aria-label={`${flagLabel}, ${count.toLocaleString()} ${t(translationKeyForCount("bin", "bins", count))}`}
            aria-pressed={selected}
            onClick={() => onToggleFlag(flag)}
          />
        );
      })}
    </Stack>
  );
}
